/**
 * This file now primarily serves to re-export the configured Api object and Axios instance
 * from Api.ts, breaking the previous circular dependency.
 */
import Api, { AxiosApi } from './Api';

// Export the configured Axios instance for potential direct use elsewhere
export { AxiosApi };

// Export the Api methods object as the default export
export default Api;
